import {existAndRun, noop} from './common';

/**
 * 执行回调
 * @param result 回调值
 * @param option 回调勾子
 * @param globalMethod 回调执行后是要销毁的函数名
 */
export const implementCallback = (result = {}, option = {}, globalMethod) => {
    switch (result.code) {
        case 0:
            existAndRun(option.success, result.data);
            break;
        case 1:
            existAndRun(option.cancel, result);
            break;
        default:
            existAndRun(option.fail, result);
    }
    existAndRun(option.complete, result);
    // 回调执行完毕，销毁全局函数
    if (globalMethod) {
        window[globalMethod] = noop;
    }
};

/**
 * 构造回调方法
 * @param option 回调勾子
 * @param fixCallback 自定义回调，兼容旧方法
 * @param isDestroyCallback 生产的回调被执行后，是否销毁，默认是
 * @returns {*} 全局函数名
 */
export const generateCallback = (option, fixCallback, isDestroyCallback = true) => {
    const globalMethod = `appCallback_${Date.now().toString(36)}${~~(Math.random() * 10000)}`;
    window[globalMethod] = function (result = {code: 0, data: {}}) {
        let res = result;
        if (fixCallback) {
            res = fixCallback(...arguments);
        }
        implementCallback(res, option, isDestroyCallback ? globalMethod : false);
    };
    return globalMethod;
};
